import { BASE_URL, FREE_BASE_URL } from "../BaseUrl.js";
import axios from "axios";

axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("cc_pssm_api");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      config.headers.Authorization = null;
    }

    return config;
  },
  function (error) {
    console.log("AN ERROR REQUEST", error);
  }
);

const currentAnnee = localStorage.getItem("currentAnnee")
  ? JSON.parse(localStorage.getItem("currentAnnee"))
  : null;

export const listeDesMotifPaiementPaginee = async (
  page = 1,
  size = 10,
  param = ""
) => {
  return await axios.get(
    BASE_URL(`motif-paiement/query?page=${page}&size=${size}&param=${param}`),
    {}
  );
};

export const listeCompleteDesMotifPaiements = async () => {
  return await axios.get(BASE_URL(`motif-paiement`), {});
};

export const listeCompleteDesMotifPaiementsFree = async () => {
  return await axios.get(FREE_BASE_URL(`motif-paiement/free`), {});
};

export const listeCompleteDesMotifPaiementsParAnnee = async (anneeId) => {
  return await axios.get(BASE_URL(`motif-paiement`), {});
};

export const recupereMotifPaiementParSonId = async (commissionId) => {
  return await axios.get(BASE_URL(`motif-paiement/${commissionId}`), {});
};

export const ajouterUneMotifPaiement = async (values) => {
  return await axios.post(BASE_URL(`motif-paiement`), values);
};

export const modifierUneMotifPaiement = async (values, commissionId) => {
  return await axios.put(BASE_URL(`motif-paiement/${commissionId}`), values);
};

export const supprimerUneMotifPaiement = async (commissionId) => {
  return await axios.delete(BASE_URL(`motif-paiement/${commissionId}`), {});
};


